/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
import http from "../../auth/http-common";

import { URL } from "../../constants/api-constants";

import { User } from "../../types/organizations";

const getCount = async (): Promise<number | undefined> => {
  try {
    const response = await http.get(URL.USERS_COUNT);
    return response.data.count;
  } catch (error) {
    console.error(error);
  }
};

const getMany = async (): Promise<User[] | undefined> => {
  try {
    const response = await http.get(URL.USERS_LIST);
    return response.data.items;
  } catch (error) {
    console.error(error);
  }
};

const getUnassignedUsers = async (): Promise<User[] | undefined> => {
  try {
    const response = await http.get(URL.USERS_UNASSIGNED);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const resetPassword = async (id: string, password: string): Promise<void> => {
  await http.put(`/users/${id}/reset-password`, { password });
};

export const usersProvider = {
  getCount,
  getMany,
  getUnassignedUsers,
  resetPassword,
};
